module.exports = __webpack_public_path__ + "img/pfizer2021.95f97eb4.png";